var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaticM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9953 0C18.6257 0 24 5.37321 24 12.0024C24 18.6315 18.6257 24 12 24C5.36954 24 3.11002e-06 18.6268 3.11002e-06 12.0024C-0.00471944 5.37321 5.36954 0 11.9953 0Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5041_11327",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.778 5.18945H4.0472V18.9719H19.778V5.18945Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5041_11327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9291 9.38768C15.641 9.22242 15.2726 9.22242 14.9468 9.38768L12.6516 10.7475L11.0932 11.6116L8.84051 12.9667C8.55243 13.1319 8.18407 13.1319 7.85822 12.9667L6.0967 11.8949C5.80863 11.7296 5.60556 11.3991 5.60556 11.0308V8.97218C5.60556 8.64166 5.77085 8.31587 6.0967 8.10812L7.85822 7.07881C8.14629 6.91355 8.51465 6.91355 8.84051 7.07881L10.602 8.15062C10.8901 8.31587 11.0932 8.64639 11.0932 9.01467V10.3745L12.6516 9.46795V8.07035C12.6516 7.73983 12.4863 7.41404 12.1605 7.20629L8.88301 5.27043C8.59493 5.10517 8.22657 5.10517 7.90072 5.27043L4.54299 7.24879C4.21713 7.41404 4.05184 7.74456 4.05184 8.07035V11.9374C4.05184 12.2679 4.21713 12.5937 4.54299 12.8014L7.86294 14.7373C8.15101 14.9025 8.51937 14.9025 8.84523 14.7373L11.0979 13.4199L12.6563 12.5134L14.909 11.1961C15.1971 11.0308 15.5654 11.0308 15.8913 11.1961L17.6528 12.2254C17.9409 12.3906 18.1439 12.7211 18.1439 13.0894V15.1481C18.1439 15.4786 17.9786 15.8044 17.6528 16.0121L15.9338 17.0414C15.6457 17.2067 15.2773 17.2067 14.9515 17.0414L13.1853 16.0121C12.8972 15.8469 12.6941 15.5163 12.6941 15.1481V13.8307L11.1357 14.7373V16.0971C11.1357 16.4276 11.301 16.7534 11.6268 16.9612L14.9468 18.897C15.2348 19.0623 15.6032 19.0623 15.9291 18.897L19.249 16.9612C19.5371 16.7959 19.7401 16.4654 19.7401 16.0971V12.1876C19.7401 11.8571 19.5749 11.5313 19.249 11.3235L15.9291 9.38768Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticM);
export default __webpack_public_path__ + "static/media/matic-m.aeea771709e7ffbae458b1389ec4db15.svg";
export { ForwardRef as ReactComponent };